module.exports = __webpack_public_path__ + "static/media/mineswiper.3f0776a7.jpeg";